import { z } from 'zod';
import { IsoDateTime, UuidString } from '../../primitives.js';
import { AttachmentBrief } from './attachment.js';

/**
 * Comment — комментарий к задаче. Хранится как TipTap JSON document
 * (pass-through, валидация на уровне editor). `content_text` производное
 * для full-text search и email plain-mode.
 *
 * `mentioned_user_ids` — детектируется backend'ом при write (BE-S12.2-10)
 * парсингом mention-узлов в TipTap JSON. Каждый mention'нутый юзер
 * автоматически добавляется в watchers задачи.
 *
 * См. `docs/STAITER_UX.md` §11.15 и `be-backlog.md` BE-S12.1-5.
 */

export const Comment = z.object({
  id: UuidString,
  entity_id: UuidString,
  task_id: UuidString,
  author_user_id: UuidString,
  /** TipTap JSON document — pass-through (без runtime validation). */
  content_json: z.unknown(),
  /** Stripped plain text для search + email. */
  content_text: z.string().max(10_000),
  mentioned_user_ids: z.array(UuidString),
  attachment_ids: z.array(UuidString),
  /**
   * B2 — денорм привязанных вложений (в порядке `attachment_ids`). Отдаётся
   * только списком комментариев; в create/patch-ответе отсутствует, поэтому
   * поле опционально.
   */
  attachments: z.array(AttachmentBrief).optional(),
  created_at: IsoDateTime,
  updated_at: IsoDateTime.nullable(),
  /** Soft-delete (видна как «Удалено» в timeline). */
  deleted_at: IsoDateTime.nullable(),
});
export type Comment = z.infer<typeof Comment>;
